export default "__VITE_ASSET__DzxhTwRD__"